import { Alert } from 'antd';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { errorToast, successToast } from 'helpers';
import { SelectedShop } from 'models';
import { call, put, takeEvery, takeLatest, delay, all } from 'redux-saga/effects';
import {
  getOrderByRankingInPosRankingAPI,
  getProgramRankAPI,
  createProgramRankAPI,
  deleteProgramRankAPI,
  updateProgramRankAPI,
  deleteOrderByImagesSliderRankingApi,
  updateOrderByImagesSliderRankingApi,
  getOrderByImagesSliderRankingApi,
  deleteImageSliderAPI,
  getImageShowRankingAPI,
  getRankingMonthPublicAPI,
  updateImageShowRankingAPI,
  getRankingDatePublicAPI,
  getImageSliderAPI,
  updateImageSliderAPI,
  addImageSliderAPI,
  updateOrderByRankingInPosRankingAPI,
  updateImageSettingAvatarRankingAPI,
  fetchHostForOrderListAPI,
  getImageSliderV2API,
  getRankingPublicGroupShopAPI,
} from 'redux/api/rankingApi';

import { rankingAction } from 'slices/rankingSlice';
import {
  getNoteAppRankingAPI,
  updateNoteAppRankingAPI,
  getRankingDateHaveDataApi,
} from 'redux/api/rankingApi';
import moment from 'moment';
import i18n from 'locales/i18n';
import { PayloadAction } from '@reduxjs/toolkit';

interface ApiErrorResponse {
  message?: string;
}

function* getOrderByRankingInPosRankingSaga(action: any) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(getOrderByRankingInPosRankingAPI, token, params);

    yield put(rankingAction.fetchOrderByRankingInPosRankingSuccess(res.data));
  } catch (error) {}
}
function* deleteImageSliderSaga(action: any) {
  const { token, id, data, onSuccess } = action.payload;

  try {
    const res: AxiosResponse = yield call(deleteImageSliderAPI, token, id, data);
    const { status } = res;
    if (status == 200) {
      yield put(rankingAction.deleteImageSliderSuccess(res.data));
      successToast('画像スライダーの削除に成功しました');
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const data = error.response?.data as ApiErrorResponse | undefined;

      errorToast(data?.message || '画像スライダーの削除に失敗しました');
    } else {
      errorToast('画像スライダーの削除に失敗しました');
    }
  }
}
function* updateImageSettingAvatarRankingSaga(action: any) {
  const { token, data } = action.payload;
  const { shop_id, imageFile, id, delete_avatar_ranking, time_update_avatar } = action.payload.data;
  const formDataFile = new FormData();

  formDataFile.append('avatar_ranking', imageFile);
  // formDataFile.append('time_update_avatar', time_update_avatar);

  formDataFile.append('shop_id', shop_id);
  formDataFile.append('id', id);
  formDataFile.append('_method', 'PUT');
  if (delete_avatar_ranking) {
    formDataFile.append('delete_avatar_ranking', delete_avatar_ranking);
  }
  try {
    const res: AxiosResponse = yield call(updateImageSettingAvatarRankingAPI, token, formDataFile);
    if (res.status === 200) {
      // successToast('イメージの更新が成功しました');
      yield put(rankingAction.updateImageSettingAvatarRankingSuccess(res.data));
    } else {
      // errorToast("", i18n.t("UPDATE_IMAGE_ERROR_500"));
      console.log('failed 500');
      errorToast('Fail to update');
    }
  } catch (error) {
    // errorToast("", i18n.t("UPDATE_IMAGE_ERROR_500"));
    console.log('failed 500');
  }
}
function* fetchHostForOrderListSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(fetchHostForOrderListAPI, token, params);
    yield put(
      rankingAction.fetchHostForOrderListSuccess({
        data: res.data.data?.data || res.data.data,
        shopId: action.payload.params.shopId,
      })
    );
  } catch (error) {
    console.log(error);
  }
}

function* updateOrderByRankingInPosRankingSaga(action: any) {
  const { token, data } = action.payload;

  try {
    const res: AxiosResponse = yield call(updateOrderByRankingInPosRankingAPI, token, data);
    yield put(rankingAction.updateOrderByRankingInPosRankingSuccess(res.data));
    // successToast('店舗リストの成功による順序の更新');
  } catch (error) {
    console.log(error);
  }
}
function* addImageSliderSaga(action: any) {
  const { resolve, reject, data, token, formData } = action.payload;
  const { shop_id, imageFile, order_by, shop_ids } = data;

  const formDataFile = new FormData();
  formDataFile.append('image', imageFile);
  formDataFile.append('order_by', String(order_by));
  formDataFile.append('type', '1');

  if (shop_id) {
    formDataFile.append('shop_id', String(shop_id));
  } else if (shop_ids && Array.isArray(shop_ids)) {
    shop_ids.forEach((id) => {
      formDataFile.append('shop_ids[]', String(id));
    });
  }

  // for (let key in formData) {
  //   if (formData[key]) {
  //     formDataFile.append(key, formData[key]);
  //   }
  // }

  try {
    const res: AxiosResponse = yield call(addImageSliderAPI, token, formDataFile);

    if (res.status === 200) {
      successToast('画像が正常に追加されました');
      yield put(rankingAction.addImageSliderSuccess(res.data));
    } else {
      console.log('error 500');
      errorToast('画像静止画の更新に失敗しました');
      yield put(rankingAction.addImageSliderFailed());
    }
  } catch (error) {
    console.log('error 500');

    reject && reject(error); // bắt lỗi
  }
}

function* addStandByMediaSaga(
  action: PayloadAction<{
    token: string;
    listMedia: Array<{
      imageFile: any;
      order_by: number;
      shop_id?: number;
      shop_ids?: Array<number>;
    }>;
  }>
) {
  const { token, listMedia } = action.payload;

  try {
    const requests = listMedia.map((item) => {
      const formDataFile = new FormData();

      formDataFile.append('image', item.imageFile);
      formDataFile.append('order_by', String(item.order_by));
      formDataFile.append('type', '1');

      if (item.shop_id) {
        formDataFile.append('shop_id', String(item.shop_id));
      } else if (item.shop_ids?.length) {
        item.shop_ids.forEach((id) => {
          formDataFile.append('shop_ids[]', String(id));
        });
      }

      return call(addImageSliderAPI, token, formDataFile);
    });

    const responses: AxiosResponse[] = yield all(requests);
    const responseData = responses.map((item) => item.data);

    yield put(rankingAction.addStandByMediaSuccess(responseData));
  } catch (error) {
    console.log('error 500');
    yield put(rankingAction.addStandByMediaFailed);
  }
}
function* getImageSliderSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getImageSliderV2API, token, params);

    yield put(rankingAction.getImageSliderSuccess(res.data));
  } catch (error) {
    console.log(error);
  }
}
function* updateImageSliderSaga(action: any) {
  const { token, data } = action.payload;

  try {
    const res: AxiosResponse = yield call(updateImageSliderAPI, token, data);
    yield put(rankingAction.updateImageSliderSuccess(res.data));
    successToast('画像の順序位置が正常に更新されました');
  } catch (error) {
    console.log(error);
  }
}
function* getRankingDateSaga(action: any) {
  const { token, shopId, dates } = action.payload;

  for (let i = 0; i < dates.length; i++) {
    const existing = JSON.parse(localStorage.getItem('rankingDate') || '[]');

    const date = existing.length + 1 === dates.length ? dates[dates.length - 1] : dates[i];
    try {
      // bật loading
      yield put(rankingAction.setLoadingRankingDate(true));

      // call API
      const res: AxiosResponse = yield call(getRankingDatePublicAPI, token, {
        shop_id: Number(shopId),
        type: 'date',
        date,
        show_rank: 1,
        key: '@Aube2021',
      });

      if (res.data) {
        // lưu localStorage nếu chưa có
        const existing = JSON.parse(localStorage.getItem('rankingDate') || '[]');
        const isExist = existing.some((item: any) => item.date === date && item.shopId === shopId);
        if (!isExist) {
          const newEntry = {
            // shopId,
            shop_id: Number(shopId),
            type: 'date',
            date,
            relatedItems: res.data,
          };
          const updatedList = [...existing, newEntry].sort(
            (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
          );
          localStorage.setItem('rankingDate', JSON.stringify(updatedList));
          // lưu vào store
          yield put(rankingAction.getRankingPublicDateSuccess(updatedList));
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      // tắt loading
      yield put(rankingAction.setLoadingRankingDate(false));

      // nếu chưa phải ngày cuối thì delay 5s
      if (i < dates.length - 1) {
        yield delay(5000);
      }
    }
  }
}
function* getRankingDatePublicSaga(action: any) {
  const { token, params, resolve, reject } = action.payload;

  try {
    // yield put(rankingAction.getRankingPublicRequest()); // Bật loading
    const res: AxiosResponse = yield call(getRankingDatePublicAPI, token, params);
    yield put(rankingAction.getRankingPublicSuccess(res.data));

    // Lấy danh sách cũ từ localStorage, parse thành mảng
    const existing = JSON.parse(localStorage.getItem('dataDateRank') || '[]');

    // Kiểm tra xem đã có phần tử nào cùng `date` và `shopId` chưa
    const isExist = existing.some(
      (item: any) => item.date === params.date && item.shop_id === params.shop_id
    );
    if (!isExist) {
      // Nếu chưa tồn tại, thì push thêm vào mảng
      const newEntry = {
        // shopId: params.shop_id,
        shop_id: Number(params.shop_id),
        type: params.type,
        date: params.date,
        relatedItems: res.data,
      };
      const updatedList = [...existing, newEntry].sort(
        (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      localStorage.setItem('dataDateRank', JSON.stringify(updatedList));
    } else {
      console.log(`Dữ liệu cho ngày ${params.date} đã tồn tại`);
    }
    resolve?.();
  } catch (error) {
    console.log('Lỗi getRankingDatePublicSaga:', error);
    yield put(rankingAction.getRankingPublicFailure(error));

    reject?.(error);
  }
}
function* getRankingPublicGroupShopSaga(action: any) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(getRankingPublicGroupShopAPI, token, params);
    const { data, status } = res;
    if (status == 200) {
      yield put(rankingAction.getRankingPublicGroupShopSuccess(data));
    }

    const existing = JSON.parse(localStorage.getItem('dataDateRankGroupShop') || '[]');

    const isExist = existing.some(
      (item: any) => item.date === params.date && item.shop_id === params.shop_id
    );
    if (!isExist) {
      const newEntry = {
        shop_ids: params.shop_ids,
        type: params.type,
        date: params.date,
        relatedItems: data,
      };
      const updatedList = [...existing, newEntry].sort(
        (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      localStorage.setItem('dataDateRankGroupShop', JSON.stringify(updatedList));
    } else {
      console.log(`Dữ liệu cho ngày ${params.date} đã tồn tại`);
    }
  } catch (error) {
    console.log('Lỗi getRankingPublicGroupShopSaga:', error);
    yield put(rankingAction.getRankingPublicGroupShopFailed());
  }
}
function* getRankingPublicMonthGroupShopSaga(action: any) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(getRankingPublicGroupShopAPI, token, params);
    const { data, status } = res;
    if (status == 200) {
      yield put(rankingAction.getRankingPublicGroupShopMonthSuccess(data));
    }

    const existing = JSON.parse(localStorage.getItem('dataMonthRankGroupShop') || '[]');

    const isExist = existing.some(
      (item: any) => item.date === params.date && item.shop_id === params.shop_id
    );
    if (!isExist) {
      const newEntry = {
        shop_ids: params.shop_ids,
        type: params.type,
        date: params.date,
        relatedItems: data,
      };
      const updatedList = [...existing, newEntry].sort(
        (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      localStorage.setItem('dataMonthRankGroupShop', JSON.stringify(updatedList));
    } else {
      console.log(`Dữ liệu cho ngày ${params.date} đã tồn tại`);
    }
  } catch (error) {
    console.log('Lỗi getRankingPublicMonthGroupShopSaga:', error);
    yield put(rankingAction.getRankingPublicGroupShopMonthFailed());
  }
}
function* getRankingDateNearestPublicSaga(action: any) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(getRankingDatePublicAPI, token, params);
    const localDataNearestDay = JSON.parse(localStorage.getItem('dataDateRankNearest') || '[]');
    const isExistData = localDataNearestDay.some(
      (item: any) => item.date === params.date && item.shop_id === params.shop_id
    );

    if (!isExistData) {
      const newEntry = {
        shop_id: Number(params.shop_id),
        type: params.type,
        date: params.date,
        relatedItems: res.data,
      };
      const updatedList = [...localDataNearestDay, newEntry].sort(
        (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
      localStorage.setItem('dataDateRankNearest', JSON.stringify(updatedList));
      yield put(rankingAction.getRankingNearestDaySuccess(updatedList));
    } else {
      console.log(`Existed dataDateRankNearest at ${params.date}`);
    }
  } catch (error) {
    console.log('Lỗi getRankingDateNearestPublicSaga:', error);
    yield put(rankingAction.getRankingNearestDayFailed());
  } finally {
    yield put(rankingAction.getRankingNearestDayFailed());
  }
}
// function* getRankingPublicMonthSaga(action: any) {
//   const { token, params } = action.payload;
//   try {
//     const res: AxiosResponse = yield call(getRankingMonthPublicAPI, token, params);
//     yield put(rankingAction.getRankingPublicMonthSuccess(res.data));
//     // Lấy danh sách cũ từ localStorage, parse thành mảng
//     const existing = JSON.parse(localStorage.getItem("dataMonthRank") || "[]");

//     // Kiểm tra xem đã có phần tử nào cùng `date` và `shopId` chưa
//     const isExist = existing.some(
//       (item: any) => item.date === params.date && item.shopId === params.shop_id
//     );

//     if (!isExist) {
//       // Nếu chưa tồn tại, thì push thêm vào mảng
//       const newEntry = {
//         shopId: params.shop_id,
//         type: params.type,
//         date: params.date,
//         relatedItems: res.data,
//       };
//       const updatedList = [...existing, newEntry]
//       localStorage.setItem("dataMonthRank", JSON.stringify(updatedList));
//     } else {
//       console.log(`Dữ liệu cho ngày ${params.date} đã tồn tại`);
//     }

//   } catch (error: any) {
//     console.log("Lỗi getRankingDatePublicSaga:", error);

//   }
// }
function* getRankingPublicMonthSaga(action: any) {
  const { token, params } = action.payload;
  try {
    yield put(rankingAction.getRankingPublicMonthRequest()); // Bật loading

    const res: AxiosResponse = yield call(getRankingMonthPublicAPI, token, params);

    const today = moment().format('YYYY-MM-DD');
    const newEntry = {
      shop_id: Number(params.shop_id),
      type: params.type,
      date: today,
      relatedItems: res.data,
    };

    // Lấy data cũ rồi chỉ giữ lại ngày hôm nay
    const existing = JSON.parse(localStorage.getItem('dataMonthRank') || '[]');
    const filtered = existing.filter(
      (item: any) => item.date === today && item.shop_id === params.shop_id
    );

    // Nếu chưa có ngày hôm nay thì thêm vào
    const isExist = filtered.length > 0;
    if (!isExist) {
      const updatedList = [...existing, newEntry]; // chỉ giữ hôm nay

      yield put(rankingAction.getRankingPublicMonthSuccess(updatedList));
      localStorage.setItem('dataMonthRank', JSON.stringify(updatedList));
    } else {
      console.log(`Dữ liệu cho ngày ${today} đã tồn tại`);
    }
  } catch (error: any) {
    console.log('Lỗi getRankingDatePublicSaga:', error);
    yield put(rankingAction.getRankingPublicMonthFailure(error.message)); // Lưu lỗi và tắt loading
  }
}
function* updateImageShowRankingSaga(action: any) {
  const { token } = action.payload;
  const { shop_id, imageFile, user_id } = action.payload.data;
  const formDataFile = new FormData();

  imageFile.forEach((item: any, index: number) => {
    formDataFile.append(`images[${index}][image]`, item.file);
    // formDataFile.append(`images[${index}][position]`, item.position);
    formDataFile.append(`images[${index}][position]`, (index % 10).toString());

    formDataFile.append(`images[${index}][type]`, (index <= 9 ? 2 : 1).toString());
  });
  formDataFile.append('shop_id', shop_id);
  formDataFile.append('user_id', user_id);

  // formDataFile.append("_method", "PUT");

  try {
    const res: AxiosResponse = yield call(updateImageShowRankingAPI, token, formDataFile);
    if (res.status === 200) {
      // successToast("イメージの更新が成功しました");

      yield put(rankingAction.updateImageShowRankingSuccess(res.data));
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      // errorToast("", i18n.t("UPDATE_IMAGE_ERROR_500"));
      console.log('falid 500');
      errorToast('Fail to update');
    }
  } catch (error) {
    // errorToast("", i18n.t("UPDATE_IMAGE_ERROR_500"));
    console.log('falid 500');
  }
}

function* getNoteAppRankingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getNoteAppRankingAPI, token, params);
    yield put(rankingAction.getNoteAppRankingSuccess(res.data));
  } catch (error: any) {
    yield put(rankingAction.getNoteAppRankingFailed());
  }
}
function* getNotePositionAppRankingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getNoteAppRankingAPI, token, params);
    yield put(rankingAction.getNotePositionAppRankingSuccess(res.data));
  } catch (error: any) {}
}
function* getNoteStaffAppRankingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getNoteAppRankingAPI, token, params);
    yield put(rankingAction.getNoteStaffAppRankingSuccess(res.data));
  } catch (error: any) {}
}
function* updateNoteAppRankingSaga(action: any) {
  const { token, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(updateNoteAppRankingAPI, token, data);
    yield put(rankingAction.updateNoteAppRankingSuccess(res.data));
    // successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}

function* getDataHaveDateRankingSaga(action: any) {
  const { token, params } = action.payload;

  try {
    const res: AxiosResponse = yield call(getRankingDateHaveDataApi, token, params.shop_id);

    yield put(
      rankingAction.getDateHaveDataRankingSuccess({
        shop_id: Number(params.shop_id),
        data: res.data,
      })
    );
  } catch (error: any) {
    yield put(rankingAction.getDateHaveDataRankingFailure());
  }
}

function* getImageShowRankingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getImageShowRankingAPI, token, params);
    yield put(rankingAction.getImageShowRankingSuccess(res.data));
  } catch (error: any) {}
}
function* getOrderByImagesSliderRankingSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(
      getOrderByImagesSliderRankingApi,
      token,
      params.shop_id,
      params.program_rank_id,
      params.permission
    );
    yield put(rankingAction.getOrderByImagesSLiderRankingSuccess(res.data));
  } catch (error: any) {
    yield put(rankingAction.getOrderByImagesSLiderRankingFailed());
  }
}
function* updateOrderByImagesSliderRankingSaga(action: any) {
  const { token, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(
      updateOrderByImagesSliderRankingApi,
      token,
      data.shop_id,
      data.shop_ids,
      data.input,
      data.type_update
    );
    yield put(rankingAction.updateOrderByImagesSliderRankingSuccess(res.data));
    // successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}
function* deleteOrderByImagesSliderRankingSaga(
  action: PayloadAction<{
    token: string;
    data: { shop_id?: number | undefined; type_delete?: number };
    id: number;
  }>
) {
  const { token, data, id } = action.payload;
  try {
    const res: AxiosResponse = yield call(
      deleteOrderByImagesSliderRankingApi,
      token,
      id,
      data.shop_id,
      data.type_delete
    );
    const { status } = res;

    if (status == 200) {
      yield put(rankingAction.deleteOrderByImagesSliderRankingSuccess(res.data.id));
      successToast('写真の削除が正常に待機中です');
    }
  } catch (error: any) {
    console.log('error');
  }
}
function* getProgramRankSaga(action: any) {
  const { token, params } = action.payload;
  try {
    const res: AxiosResponse = yield call(getProgramRankAPI, token, params);
    yield put(rankingAction.getProgramRankSuccess(res.data));
  } catch (error: any) {
    yield put(rankingAction.getProgramRankFailed());
  }
}
function* createProgramRankSaga(action: any) {
  const { token, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(createProgramRankAPI, token, data);
    yield put(rankingAction.createProgramRankSuccess(res.data));
    successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}
function* updateProgramRankSaga(action: any) {
  const { token, id, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(updateProgramRankAPI, token, id, data);
    yield put(rankingAction.updateProgramRankSuccess(res.data));
    // successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}
function* updateNoteWithOptionRankSaga(action: any) {
  const { token, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(updateNoteAppRankingAPI, token, data);
    yield put(rankingAction.updateNoteWithOptionRankSuccess(res.data));
    // successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}
function* deleteProgramRankSaga(action: any) {
  const { token, id, data } = action.payload;
  try {
    const res: AxiosResponse = yield call(deleteProgramRankAPI, token, id, data.shop_id);
    yield put(rankingAction.deleteProgramRankSuccess(res.data));
    successToast(i18n.t('UPDATE_SUCCESS'));
  } catch (error: any) {}
}
export default function* rankingSaga() {
  yield takeLatest(
    rankingAction.fetchOrderByRankingInPosRanking.type,
    getOrderByRankingInPosRankingSaga
  );
  yield takeLatest(rankingAction.deleteImageSlider.type, deleteImageSliderSaga);
  yield takeLatest(
    rankingAction.updateImageSettingAvatarRanking.type,
    updateImageSettingAvatarRankingSaga
  );
  yield takeEvery(rankingAction.fetchHostForOrderList.type, fetchHostForOrderListSaga);
  yield takeLatest(
    rankingAction.updateOrderByRankingInPosRanking.type,
    updateOrderByRankingInPosRankingSaga
  );
  yield takeLatest(rankingAction.addImageSlider.type, addImageSliderSaga);
  yield takeLatest(rankingAction.addStandByMedia.type, addStandByMediaSaga);
  yield takeEvery(rankingAction.getImageSlider.type, getImageSliderSaga);
  yield takeLatest(rankingAction.updateImageSlider.type, updateImageSliderSaga);
  yield takeEvery(rankingAction.getRankingPublic.type, getRankingDatePublicSaga);
  yield takeEvery(rankingAction.getRankingNearestDayPublic.type, getRankingDateNearestPublicSaga);
  yield takeEvery(rankingAction.getRankingMonthPublic.type, getRankingPublicMonthSaga);
  yield takeLatest(rankingAction.updateImageShowRanking.type, updateImageShowRankingSaga);

  yield takeEvery(
    rankingAction.getOrderByImagesSLiderRanking.type,
    getOrderByImagesSliderRankingSaga
  );

  yield takeEvery(rankingAction.getNoteAppRanking.type, getNoteAppRankingSaga);
  yield takeEvery(rankingAction.getNotePositionAppRanking.type, getNotePositionAppRankingSaga);

  yield takeLatest(rankingAction.getNoteStaffAppRanking.type, getNoteStaffAppRankingSaga);
  yield takeLatest(rankingAction.updateNoteAppRanking.type, updateNoteAppRankingSaga);
  yield takeEvery(rankingAction.getDateHaveDataRanking.type, getDataHaveDateRankingSaga);
  yield takeEvery(rankingAction.getImageShowRanking.type, getImageShowRankingSaga);
  yield takeEvery(
    rankingAction.updateOrderByImagesSliderRanking.type,
    updateOrderByImagesSliderRankingSaga
  );
  yield takeEvery(
    rankingAction.deleteOrderByImagesSliderRanking.type,
    deleteOrderByImagesSliderRankingSaga
  );
  yield takeEvery(rankingAction.getProgramRank.type, getProgramRankSaga);
  yield takeLatest(rankingAction.createProgramRank.type, createProgramRankSaga);
  yield takeEvery(rankingAction.updateProgramRank.type, updateProgramRankSaga);
  yield takeEvery(rankingAction.updateNoteWithOptionRank.type, updateNoteWithOptionRankSaga);
  yield takeEvery(rankingAction.getRankingPublicDate.type, getRankingDateSaga);
  yield takeLatest(rankingAction.deleteProgramRank.type, deleteProgramRankSaga);
  yield takeLatest(rankingAction.getRankingPublicGroupShop.type, getRankingPublicGroupShopSaga);
  yield takeLatest(
    rankingAction.getRankingPublicGroupShopMonth.type,
    getRankingPublicMonthGroupShopSaga
  );
}
